import React from 'react'
import './Item.css'
import {useTranslation} from "react-i18next";

function Item({img, title, description, linkweb, linkgithub, tags}) {
    const {t, i18n} = useTranslation('common');
    return (
        <div className="item">
            <div className="img__scroll">
                <a href={linkweb} target="_blank">
                <img className="item__image" src={img} alt=""/></a>
            </div>
            <div className="item__description">
            <h3>{title}</h3>
            <p>{description}</p>
            <div className="links">
                <button className="webButton" onClick={() =>{window.open(linkweb, "_blank");}} >{t('portfolio.p8')}</button>
                <button className="gitButton" onClick={() =>{window.open(linkgithub, "_blank");}}>{t('portfolio.p9')}</button>
            </div>
            <div className="tags">
                {
                tags.split(';').map((tag) =>
                    <p>{tag}</p>
                )}
            </div>
            </div>
        </div>
    )
}

export default Item
